import styled from "styled-components";
import RowOption from '../rowOption.jsx'



const Container=styled.div`
	width:100%;
	display:flex;
	align-items:center;
	color:white
`
const Info=styled.div`
	width:95%;
	border-radius:10px;
	display:flex;
	flex-direction:column;
	align-items:center;
	margin-bottom:15px;
	padding:15px
`


export default function BasicInfoUser(props){
	
	let{ value,action,estado}=props;

	return(
		<Container>		
      			<h1>Basico</h1>
 				<Info>	
 					<RowOption label="name" value={value.name} action={action} estado={estado} />
 					<RowOption label="usuario" value={value.usuario} action={action} estado={estado} />
 					<RowOption label="password" value={value.password} action={action} estado={estado} />
 					<RowOption label="correo" value={value.correo} action={action} estado={estado} />											
 				</Info>			
 		</Container>

		)
}